import { Rectangle } from '@aid/customers/types/classes';
import { ContractSignType } from '@aid/customers/types/enums';
import { MessageFileSign } from '@aid/chat/types/classes';

export class ContractSignArea {
  id?: number;
  index?: number;
  type?: ContractSignType;
  description?: string;
  area?: Rectangle;
  page?: number;
  scale?: number;
  pageHeight?: number;

  getMessageFileSign(): MessageFileSign {
    const area = this.area;
    if (!area) {
      throw new Error('A contract sign needs a placed area.');
    }
    const sign = new MessageFileSign();
    sign.index = this.index;
    sign.description = this.description;
    sign.x = area.x;
    sign.y = area.y;
    sign.type = this.type;
    sign.height = area.height;
    sign.width = area.width;
    sign.page = this.page;
    sign.scale = this.scale;
    sign.pageHeight = this.pageHeight;

    return sign;
  }
}
